
export const MAIN_SECTION_ID = 'main-section';
export const TEAM_OF_PROFESSIONALS_ID = 'team-of-professionals';
export const WHO_WE_ARE_ID = 'who-we-are';
export const ABOUT_US_ID = 'about-us';
export const ONLINE_BUSINESS_CONSULTING_ID = 'online-business-consulting';
export const GET_IN_TOUCH_FORM_ID = 'get-in-touch-form';

export const scrollToElement = (elementId: string) => {
  const targetSection = document.getElementById(elementId);
  if (targetSection) {
    window.scrollTo({
      top: targetSection?.offsetTop - 140, // header offset
      behavior: 'smooth'
    })
  }
}